// Single source of truth for external profile links, résumé, and credentials.
// Update these values here and they propagate across the header, footer,
// hero, and contact page. Set a social URL to null to hide that icon/link.

export const SITE = {
  name: "Maxwell Ferreira",
  role: "Offensive Security · Penetration Testing · Red Team",
  email: "maxwell.pentest@gmail.com",

  // Social / external profiles. null => link is hidden everywhere.
  social: {
    github: null,
    linkedin: "https://www.linkedin.com/in/maxwell-ferreira",
    // Hack The Box profile — verifiable proof beats a claim on a page.
    hackTheBox: "https://profile.hackthebox.com/profile/019eceba-50fc-7273-821c-0f33cad1ebc0",
    // Donation link is deliberately off. Next to "Hire me" it splits the
    // single action that matters, and it frames the author as a hobbyist to
    // the consultancies reading this page. Set a URL here to bring it back.
    buyMeACoffee: null,
  },

  // Résumé: drop your PDF at frontend/public/resume.pdf (served from /resume.pdf).
  resumeUrl: "/resume.pdf",

  // Author photo. A real face is the single biggest trust signal on a page
  // that is about one person. Square, served from frontend/public/.
  photoUrl: "/maxwell.jpg",
};

// Credentials surfaced in the hero credential bar (most → least senior).
export const CREDENTIALS = ["OSCP+", "CRTO", "eWPTXv2", "eJPT", "Pentest+"];
